<template>
  <validation-provider v-slot="{errors}"
                       :vid="$attrs.vid"
                       :name="$attrs.vname"
                       :mode="mode"
                       :immediate="immediate"
                       :rules="rules"
                       :bails="bails">

    <base-yn v-model="innerValue"
             ref="baseYn"
             :error-messages="resolveErrorMessagesHidden(errors)"
             :error="errors.length > 0"
             :id="$attrs.vid"
             v-bind="$attrs"
             :disabled="disabled"></base-yn>
  </validation-provider>
</template>
<script>
import BaseInputValidate from './BaseInputValidate'
import BaseYN from '@/components/Base/BaseYN'
export default {
  name: 'b-base-yn',

  extends: BaseInputValidate,

  components: { [BaseYN.Name]: BaseYN },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    immediate: Boolean
  },

  methods: {
    secondBtnHandler () {
      this.$refs['baseYn'].secondBtnHandler()
    }
  }
}
</script>
